import Entity from './entity'
export default class Company extends Entity<number>{
    cName:string;
    status:Number=1;
}